import React from 'react';
import Router from './Router';
import GlobalModule from './components/Modules/GlobalModule';
import "./App.css"

const App = () => {
  return (
    <GlobalModule>
      <Router />
    </GlobalModule>

  )
}

export default App